const state = {
	radius: 3000,
	isMapOpen: false,
	cord: {
		lat: 0,
		lng: 0
	},
	searchCord: {

	}
};

const mutations = {
	setIsMapOpen: (state) => {	
		if (window.innerWidth < 1200) {		
			const header = document.getElementById('header');
			const navSearch = document.getElementById('navSearch');
			document.body.classList.toggle('map-opend');
			header.classList.toggle('top');
			navSearch.classList.toggle('top');
		}
		state.isMapOpen = !state.isMapOpen
	},
	setSearchCord: (state, payload) => {
		state.searchCord = payload
	},
	setRadius: (state, payload) => {
		state.radius = payload
	},
	setCord: (state, payload) => {
		state.cord = payload

	},
};

const actions = {

};

export default {
	namespaced: true,
	state,
	actions,
	mutations
};